module.exports = "//public.getcloudapp.com/packs/media/images/icons-notifications-active-3cd2a48078afc86b416e389414aa3863.svg";